import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from '@/utils';
import React, { useCallback, useState } from 'react';
const variantStyles = {
    line: {
        tabs: 'gap-2',
        // A <button> does not inherit `color` — the UA pins it to `buttontext`, which
        // is black. Without an explicit colour the labels were invisible in dark mode.
        tab: 'border-b-4 border-transparent p-2 text-dash-text2 hover:text-dash-text transition-colors',
        tabSelected: 'border-b-4 border-vjwPrimary text-dash-text',
    },
    enclosed: {
        tab: 'py-2 px-4 rounded-t',
        tabSelected: 'border bg-gray-100 border-b-0',
    },
    solid: {
        tab: 'py-2 px-4 bg-white',
        tabSelected: 'text-white bg-vjwPrimary',
    },
};
function Tab({ children, index, selectedTab, handleSelect, variant, lastIndex }) {
    const isSelected = selectedTab === index;
    const className = `${cn(`${variantStyles[variant].tab} ${isSelected ? variantStyles[variant].tabSelected : ''}`, {
        'rounded-s-md': index === 0 && variant === 'solid',
        'rounded-e-md': index === lastIndex && variant === 'solid',
    })}`;
    return (_jsx("button", { type: 'button', className: className, onClick: () => handleSelect(index), children: children }));
}
export function TabPanel({ children, className }) {
    return _jsx("div", { className: className, children: children });
}
function TabPanels({ children, selectedTab, variant }) {
    return React.Children.map(children, (child, index) => {
        var _a;
        if (!child)
            return null;
        const className = child.props.className
            ? `${child.props.className} ${(_a = variantStyles[variant].tabPanel) !== null && _a !== void 0 ? _a : ''}`
            : variantStyles[variant].tabPanel;
        if (index === selectedTab && child.type === TabPanel) {
            return _jsx(TabPanel, { className: className, children: child.props.children });
        }
        return null;
    });
}
export function Tabs({ tabs, variant = 'line', tabIndex = 0, onTabChange, children, tabsClassName, }) {
    var _a;
    const [selectedTab, setSelectedTab] = useState(tabIndex);
    const handleSelect = useCallback((index) => {
        setSelectedTab(index);
        if (onTabChange) {
            onTabChange(index);
        }
    }, [onTabChange]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cn(`flex flex-wrap items-center justify-between ${tabsClassName}`), children: [_jsx("div", { className: `flex flex-wrap ${(_a = variantStyles[variant].tabs) !== null && _a !== void 0 ? _a : ''}`, style: variant === 'solid'
                            ? {
                                display: 'grid',
                                gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            }
                            : {}, children: tabs.map((tab, index) => (_jsxs(React.Fragment, { children: [index !== 0 && variant === 'line' && (_jsx("div", { className: 'my-2 h-auto w-0.5 bg-dash-border' })), _jsx(Tab, { index: index, lastIndex: tabs.length - 1, selectedTab: selectedTab, handleSelect: handleSelect, variant: variant, children: tab.label })] }, `tab-${tab.label}`))) }), _jsx("div", { className: 'flex flex-wrap', children: tabs.map((tab, index) => tab.secondaryAction &&
                            selectedTab === index && (_jsx("div", { className: 'secondary-action', children: tab.secondaryAction }, `tab-secondary-action-${tab.label}`))) })] }), _jsx(TabPanels, { selectedTab: selectedTab, variant: variant, children: children })] }));
}
